import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import './App.css';
import Header from './components/shared/Header';
import Footer from './components/shared/Footer';
import Home from './pages/Home';
import WhoWeServe from './sections/home/WhoWeServe';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import Login from './pages/Login';
import ScheduleDemo from './pages/ScheduleDemo';
import ScrollToTop from './components/shared/ScrollToTop';
import { AppProvider } from './AppContext';
import { ServicesRouter } from 'routers';
import Termsofuse from './pages/Termsofuse';
import Privacypolicy from './pages/Privacypolicy';
import { useScrollRestoration } from 'hooks/index.js';
 
// MainLayout component that includes the header
const MainLayout = () => {
  useScrollRestoration();

  return (
    <>
      <Header />
      <Outlet /> 
      <Footer />
    </>
  );
};
 
const AppRoutes = () => {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/services/:slug?" element={<ServicesRouter />} />
        <Route path="/who-we-serve/:slug?" element={<WhoWeServe />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/login" element={<Login />} />
        <Route path="/schedule-demo" element={<ScheduleDemo />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/termsofuse" element={<Termsofuse/>} />
        <Route path="/privacypolicy" element={<Privacypolicy/>} />
      </Route>
      <Route path="/" element={<Home />} />
      <Route path="*" element={<Home />} />
    </Routes>
  );
};
 
const App = () => {
  return (
    <AppProvider>
        <Router>
          <ScrollToTop />
          <AppRoutes />
        </Router>
    </AppProvider>
  );
};
 
export default App;